<script setup>

import AllGradesChips from '@/components/home/AllGradesChips.vue'
import ClassinoClasses from '@/components/home/ClassinoClasses.vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import { ref } from 'vue'
const CourseRepo =  RepositoryFactory.get('Course')
const DEFAULT_GRADE = 12
const randomCourses = ref('')
const getRandomProduct = async function(id) {
  try {
    const {data : { data }} = await CourseRepo.getRandom(id)
    randomCourses.value = data
  } catch (e){
    console.log(e)
  }
}
getRandomProduct(DEFAULT_GRADE)

</script>

<template>
  <v-container tag="section" class="cl__section__margin__bottom">
    <v-row class="mb-16">
      <v-col cols="12" class="d-flex justify-center text-center">
        <h1 class="font-weight-bold cl-section__title">کلاس‌های تحصیلی برای همه پایه‌ها</h1>
      </v-col>
    </v-row>
    <AllGradesChips @atChangeChip="getRandomProduct($event)"></AllGradesChips>
    <ClassinoClasses v-if="randomCourses.length > 0" :items="randomCourses"></ClassinoClasses>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn
          size="large"
          color="#155EEF"
          class="rounded-lg my-4 text-decoration-none"
          style="letter-spacing: 0"
          :to="{name:'courses'}"
          :width="$vuetify.display.mdAndDown?'100%':''"
        >
          مشاهده همه دوره‌ها
          <v-icon icon="$mdiChevronLeftBoxOutline" class="mx-2"></v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">

</style>
